import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
    {
        trackingLabel: 'About Us',
        enablerKey: 'isAboutUsPageEnabled',
        href: '/about/',
        dataTn: 'footer-about-us',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_about_us" defaultMessage="About Us" />
        ),
    },
    {
        trackingLabel: 'Blog',
        href: 'https://www.1stdibs.com/blogs/the-study/',
        dataTn: 'footer-blog',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_blog" defaultMessage="Blog" />
        ),
    },
    {
        trackingLabel: 'Magazine',
        href: 'https://www.1stdibs.com/introspective-magazine/',
        dataTn: 'footer-magazine',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_magazine" defaultMessage="Magazine" />
        ),
    },
    {
        trackingLabel: 'Questions & Answers',
        enablerKey: 'isQuestionsPageEnabled',
        href: '/answers/',
        dataTn: 'footer-qa',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.siteLinksQa" defaultMessage="Questions & Answers" />
        ),
    },
    {
        trackingLabel: 'Careers',
        enablerKey: 'isCareersPageEnabled',
        href: '/about/careers/',
        dataTn: 'footer-jobs',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_jobs" defaultMessage="Careers" />
        ),
    },
    {
        trackingLabel: 'Press',
        enablerKey: 'isPressPageEnabled',
        href: '/about/press/',
        dataTn: 'footer-press',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_press" defaultMessage="Press" />
        ),
    },
    {
        trackingLabel: 'Support Center',
        href: 'https://support.1stdibs.com/',
        target: '_blank',
        dataTn: 'footer-support',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_support" defaultMessage="Support Center" />
        ),
    },
];
